import styled from '@emotion/styled';
import MuiGrid from '@mui/material/Grid';
export const Grid = styled(MuiGrid)`
  display: flex;
  align-items: center;
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
`;
